<div class="metric-list">
  @for (item of items; track $index) {
    <div class="metric-row">
      <span class="metric-label">{{ item.label }}</span>
      <div class="metric-bar">
        <div class="metric-fill"
             [style.width.%]="item.porcentaje"
             [style.background]="item.color">
        </div>
      </div>
      <b class="metric-value">{{ item.value }}</b>
      <b class="metric-pct" [style.color]="item.labelColor || null">
        {{ item.porcentajeLabel ?? (item.porcentaje + '%') }}
      </b>
    </div>
  }
  @if (config.total) {
    <div class="metric-row total-row">
      <span class="metric-label">{{ config.total.label }}</span>
      <div></div>
      <b class="metric-value">{{ config.total.value }}</b>
      <b class="metric-pct">{{ config.total.porcentajeLabel }}</b>
    </div>
  }


</div>
